import React, { useContext, useState } from 'react'
import { useForm } from 'react-hook-form';
import { baseUrl, mainSiteBaseUrl, path, TOKEN_KEY } from '../../constants';
import axios from 'axios'
import { appContext } from '../../Context/appProvider';
import { useNavigate, Link } from 'react-router-dom';
import { Oval } from 'react-loader-spinner'
import Logo from '../../assets/logo.png'
import OtpInput from 'react-otp-input';

export default function Signin() {
    const {setToken} = useContext(appContext)
    const navigate = useNavigate()
    const { register, handleSubmit, watch, formState: { errors, isSubmitting } } = useForm();
    const [error, setError] = useState(null)
    const [signupMethod, setSignupMethod] = useState({method: 'phone', value: '', action: 'phonelogin'})
    const [step, setStep] = useState(1) // 1 phpne/email, 2 - otp, 3 - information
    const [otp, setOtp] = useState('');
    const [otpChecking, setOtpChecking] = useState(false)
    const isEmail = signupMethod.method == 'email'



    const onSubmit = data => {
      console.log(data)
      return new Promise((resolve, reject) => {
        // const path = signupMethod.method == 'phone' ? '/send-otp' : '/login'
        setError()
        axios(baseUrl + '/api/common' + '/login', {
          method: 'post',
          data: {
            ...data,
            method: isEmail ? "email" : 'phone'
          }
        }).then(response => {
          const data = response.data
          resolve(true)
          console.log(response.data)
          if(data.success){
            localStorage.setItem(TOKEN_KEY, response.data.token)
            setToken(data.token)
            navigate('/')
          } else setError(data.message)
        })
        .catch(e => {
          resolve(true)
          setError('Network Error')
        })
      })
    }

    const changeMethod = (method) => {
      setSignupMethod(s => ({...s, method}))
    }
  
    const onOtpChange = (value) => {
      setOtp(value)
      if(value.length == 4){
        setOtpChecking(true)
        axios(baseUrl + '/api/common/verify', {
          method: 'post',
          data: {
            code: value,
            identifier: signupMethod.value,
            action: 'phonelogin'
          }
        }).then(response => {
          const data = response.data
          if(data.success){
            localStorage.setItem('hwtoken', response.data.token)
            setToken(data.token)
            navigate('/')
          } else setError('Invalid Code!')
        }).finally(() => setOtpChecking(false))
      }
    }

    return (
    <div className='w-screen h-screen flex items-center justify-center bg-lightGrey'>
        <div className='bg-white rounded-md shadow-md flex flex-col p-5 w-[400px] items-center gap-3'>
            <img src={Logo} className='w-[80px] object-contain' />
            <p className='text-[16px] text-black font-bold'>Seller Login </p>
            <span className='text-sm text-[#00000080]'>(Use your HuluWare account)</span>
            {error && (
                <p className='bg-[#f946464f] animate-bounce-slow ease-linear text-[#f94646] text-[15px] font-bold px-10 py-2 rounded-sm'>
                {error}
                </p>
            )}
            <form onSubmit={handleSubmit(onSubmit)} className='flex flex-col gap-3 w-full'>
            {(step == 2 && !error) &&  <p className='bg-[#36af014f] text-[#1a6500] text-[15px] text-center font-bold px-10 py-2 rounded-sm'>OTP Sent!</p>}
            {step == 1 && <div className='rounded-[30px] p-2 bg-[#00000030] shadow-md self-center'>
              <button onClick={() => changeMethod('phone')} className={`rounded-[30px] px-4 py-1 border-none outline-none ${!isEmail ? 'bg-black text-white' : 'bg-none text-black'}`} type='button'>
                Phone
              </button>
              <button onClick={() => changeMethod('email')} className={`rounded-[30px] px-4 py-1 border-none outline-none ${isEmail ? 'bg-black text-white' : 'bg-none text-black'}`} type='button'>
                Email
              </button>
            </div> }  

            { signupMethod.method == 'email' ? (
              <>
                <input {...register('email')} placeholder='Email' type='text' className='text-black border-[1px] border-black rounded-md p-2 pl-4'  />
                <input {...register('password')} placeholder='Password' type='password' className='text-black border-[1px] border-black rounded-md p-2 pl-4'  />
              </>
            ) : step == 1 ? (
              <>
                <input  {...register('phone')} placeholder={'Phone Number (09xxxxxxxx)'} type={'number'} className='text-black border-[1px] border-black rounded-md p-2 pl-4' required />
                <input {...register('password')} placeholder='Password' type='password' className='text-black border-[1px] border-black rounded-md p-2 pl-4' required />
              </>
            ) : (
                <></>
              // <OtpInput
              //   value={otp}
              //   onChange={onOtpChange}
              //   containerStyle={'self-center'}
              //   numInputs={4}
              //   inputStyle={'border-[1px] border-black p-3 !w-[40px] rounded-md'}
              //   renderSeparator={<span style={{marginLeft: 5, marginRight: 5 }}></span>}
              //   renderInput={(props) => <input style={{border: '1px sold #000000'}} {...props} />}
              // />
            )}

            {step != 2 && <button className='bg-main text-white text-[20px] rounded-md p-2 flex items-center justify-center' type='submit'>
              {isSubmitting ? (
                <Oval
                visible={true}
                height="30"
                width="30"
                color="#ffffff"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
                strokeWidth={3}
                />
              ) : 'Login'}
              </button> }
              {otpChecking && (
                <Oval
                visible={true}
                height="30"
                width="30"
                color="#52a4e0"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
                strokeWidth={3}
                />
              )}
               <hr className='w-full text-[#00000040]'/>
              <div className='w-full flex items-center justify-center px-6'>
                <Link to={mainSiteBaseUrl + '/signup?next=https://seller.hulluware.com'} className='text-[13px] text-[#4848ff]'>Create Account</Link>
              </div>
            </form>
        </div>
    </div>
    )
}
